import {
    ADD_CUSTOMER_UPLAOD_REQUEST, ADD_CUSTOMER_UPLAOD_SUCCESS, ADD_CUSTOMER_UPLAOD_ERROR, GET_CUSTOMER_UPLAOD_REQUEST, GET_CUSTOMER_UPLAOD_SUCCESS,
    GET_CUSTOMER_UPLAOD_ERROR, DOWNLOAD_CUSTOMER_FILE_REQUEST, DOWNLOAD_CUSTOMER_FILE_SUCCESS, DOWNLOAD_CUSTOMER_FILE_ERROR, UPDATE_CUSTOMER_UPLAOD_REQUEST, UPDATE_CUSTOMER_UPLAOD_SUCCESS, UPDATE_CUSTOMER_UPLAOD_ERROR,
    DELETE_CUSTOMER_FILE_REQUEST,
    DELETE_CUSTOMER_FILE_SUCCESS,
    DELETE_CUSTOMER_FILE_ERROR
} from "./types"
import { BASEURL } from "../../constant/config.js";
import { BASEURL1 } from "../../constant/config.js";
const axios = require("axios");


export const addCustomerUpload = (
    { token,
        customer_id,
        remarks,
        file_type,
        file,
        document_type }
) => (dispatch) => {

    dispatch({ type: ADD_CUSTOMER_UPLAOD_REQUEST });
    console.log("file", file[0].originFileObj)
    let data = new FormData();
    data.append('file', file[0].originFileObj);
    data.append('remarks', remarks);
    data.append('file_type', file_type);
    data.append('customer_id', customer_id);
    data.append('document_type', document_type);



    return axios({
        method: "POST",
        url: `${BASEURL}uploads/customerCommunication/${customer_id}`,
        data: data,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
            "Content-Type": "multipart/form-data"
        },
    })
        .then((response) => {

            return dispatch({ type: ADD_CUSTOMER_UPLAOD_SUCCESS, payload: response.data });
        })
        .catch((error) => {

            return dispatch({
                type: ADD_CUSTOMER_UPLAOD_ERROR,
                payload: error.response,
            });
        });
};

export const updateCustomerUpload = (token, data, id, fileName) => (dispatch) => {

    dispatch({ type: UPDATE_CUSTOMER_UPLAOD_REQUEST });


    return axios({
        method: "POST",
        url: `${BASEURL}upload/customerCommUpdate/${id}`,
        data: data,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token
        },
    })
        .then((response) => {

            return dispatch({ type: UPDATE_CUSTOMER_UPLAOD_SUCCESS, payload: response.data });
        })
        .catch((error) => {

            return dispatch({
                type: UPDATE_CUSTOMER_UPLAOD_ERROR,
                payload: error.response,
            });
        });
};

export const getCustomerUpload = (token, id) => dispatch => {
    dispatch({ type: GET_CUSTOMER_UPLAOD_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/customerCommunication`,
        data: {
            customer_id: id
        },
        headers: {
            Accept: "application/json",
            'Authorization': 'Bearer ' + token
        }
    })
        .then(response => {
            return dispatch({ type: GET_CUSTOMER_UPLAOD_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: GET_CUSTOMER_UPLAOD_ERROR,
                payload: error.response,
            });
        })
}

export const downloadCustomerFile = (token, fileName) => dispatch => {
    dispatch({ type: DOWNLOAD_CUSTOMER_FILE_REQUEST });
    return axios({
        method: "GET",

        url: `${BASEURL1}${"test.csv"}`,
        headers: {
            Accept: "application/json",
            'Authorization': 'Bearer ' + token
        }
    })
        .then(response => {
            return dispatch({ type: DOWNLOAD_CUSTOMER_FILE_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: DOWNLOAD_CUSTOMER_FILE_ERROR,
                payload: error.response,
            });
        })
}

export const deleteCustomerFile = (token, id) => dispatch => {
    dispatch({ type: DELETE_CUSTOMER_FILE_REQUEST });
    return axios({
        method: "DELETE",

        url: `${BASEURL}delete/customerCommunication/${id}`,
        headers: {
            Accept: "application/json",
            'Authorization': 'Bearer ' + token
        }
    })
        .then(response => {
            return dispatch({ type: DELETE_CUSTOMER_FILE_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: DELETE_CUSTOMER_FILE_ERROR,
                payload: error.response,
            });
        })
}
